// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_9e1425b4d3--wrapper--RJ0N3","_clickable":"_9e1425b4d3--_clickable--jwCmE","inner-wrapper":"_9e1425b4d3--inner-wrapper--sKIGs"};